<template>
  <div>
    <div class="d-flex-center justify-content-center social-post-share-wrapper">
      <div class="social-post-share">
        Share:&nbsp;
        <div
          class="social-shared-item"
          v-for="(item, name, index) in socialList"
          :key="index"
        >
          <a
            v-if="name == 'email'"
            href="javascript:void(0)"
            @click.prevent="showModal = true"
            :class="[item.class, { off: index > 10 && toggleSharedLink }]"
          >
            <i :class="item.icon"></i>
          </a>
          <a
            v-else
            :href="item.url + sharedUrl"
            target="_blank"
            :class="[item.class, { off: index > 10 && toggleSharedLink }]"
          >
            <i :class="item.icon"></i>
          </a>
        </div>
      </div>
      <span
        v-show="Object.keys(socialList).length > 11"
        @click="toggleSharedLink = !toggleSharedLink"
      >
        <i
          class="far"
          :class="{
            'fa-plus': toggleSharedLink,
            'fa-minus': !toggleSharedLink,
          }"
        ></i>
      </span>
      <send-email
        :EventshowModal="showModal"
        :jobTitle="jobTitle"
        :emailUrl="emailUrl"
      ></send-email>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "jobTitle",
    "emailUrl",
    "socialList",
    "sharedUrl",
  ],
  data() {
    return {
      showModal: false,
      toggleSharedLink: true,
    };
  },
  components: {
    "send-email": require("./email-modal").default,
  },
};
</script>

<style lang="scss">
</style>
